/**
 * @fileoverview POST handler for the "/inbox_vision/:app_group_id/set_default_preview_ids" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { inboxVisionAppGroupIdSetDefaultPreviewIdsCacheKeys } from "./constants";
import type {
  InboxVisionAppGroupIdSetDefaultPreviewIdsResult,
  PostInboxVisionAppGroupIdSetDefaultPreviewIdsProps,
} from "./types";

export const postInboxVisionAppGroupIdSetDefaultPreviewIds = reactQueryMutationAdapter(
  inboxVisionAppGroupIdSetDefaultPreviewIdsCacheKeys,
  (
    props: PostInboxVisionAppGroupIdSetDefaultPreviewIdsProps
  ): Promise<InboxVisionAppGroupIdSetDefaultPreviewIdsResult> => {
    return fetch(`/inbox_vision/${props.appGroupId}/set_default_preview_ids`, "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
